import { useState } from "react"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../../ui/dialog"
import { RadioGroup, RadioGroupItem } from "../../ui/radio-group"
import { Label } from "../../ui/label"
import { Input } from "../../ui/input"
import { Button } from "../../ui/button"

interface GlamPackage {
  id: string
  title: string
  price: number
  description: string
  image_path: string
  created_at: string
  updated_at: string
}

interface QuoteRequest {
  id: string
  name: string
  email_address: string
  phone_number: string
  glam_package_id: string
  glam_spot: string
  number_of_faces: string
  booking_start_date: string
  booking_end_date: string
  booking_start_date_time: string
  booking_end_date_time: string
  home_address: string | null
  landmark: string | null
  additional_info: string | null
  google_calendar_link: string | null
  booking_name: string
  created_at: string
  updated_at: string
  glam_package: GlamPackage
  status?: "pending" | "completed" | "canceled"
  cost?: number
}

interface UpdateQuoteModalProps {
  isOpen: boolean
  onClose: () => void
  onUpdate: (data: Partial<QuoteRequest>) => void
  quote: QuoteRequest
}

export function UpdateQuoteModal({ isOpen, onClose, onUpdate, quote }: UpdateQuoteModalProps) {
  // Default to "pending" if status is not defined
  const [status, setStatus] = useState<string>(quote.status || "pending")
  const [cost, setCost] = useState<string>(quote.cost?.toString() || "")

  const handleSubmit = () => {
    onUpdate({
      status: status as "pending" | "completed" | "canceled",
      cost: cost ? Number.parseFloat(cost) : undefined,
    })
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Update Quote Request</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="space-y-2">
            <h4 className="font-medium">Status</h4>
            <RadioGroup value={status} onValueChange={setStatus} className="flex flex-col space-y-1">
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="pending" id="pending" />
                <Label htmlFor="pending">Pending</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="completed" id="completed" />
                <Label htmlFor="completed">Convert to Booking</Label>
              </div>
              <div className="flex items-center space-x-2">
                <RadioGroupItem value="canceled" id="canceled" />
                <Label htmlFor="canceled">Cancel</Label>
              </div>
            </RadioGroup>
          </div>
          <div className="space-y-2">
            <Label htmlFor="cost">Cost ($)</Label>
            <Input
              id="cost"
              placeholder="Enter cost amount"
              value={cost}
              onChange={(e) => setCost(e.target.value)}
              type="number"
              min="0"
              step="0.01"
            />
          </div>
        </div>
        <DialogFooter className="flex justify-between sm:justify-between">
          <Button variant="outline" onClick={onClose} className="border-gray-300 text-gray-700">
            CLOSE
          </Button>
          <Button onClick={handleSubmit} className="bg-[#B87775] hover:bg-[#a56967] text-white">
            SAVE CHANGES
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
